// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import cn from 'classnames';
import {Button} from '../../../../hola/pub/lib/button';
import {t_countries} from '../../lib/use_dashboard_data';
import {Plan_history} from './plan_history';
import {Active_plans} from './active_plans';
import {has_active_plan, show_free_plan_promo} from './utils';
import {Welcome_promo} from './welcome_promo';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import {use_debug_ui} from '../../../../hola/pub/lib/debug';
import {Api_token_panel} from './api_token_panel';
import {www_hola} from 'hola_opt';
import {Pricing_cards} from './pricing_plans';
import {App_context} from 'hola_app_context';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Rate_us} from './rate_us/rate_us';
import {use_app_context} from '../../lib/app_context';
import {Settings_context} from '../../../../hola/pub/settings_ctx';

import styles from '../../pages/toolip.io/dashboard.module.less';

interface i_my_plans_props {
    countries?: t_countries;
    need_login: ()=>void;
}

export const My_plans = (props: i_my_plans_props)=>{
    const {user} = useContext(App_context);
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const {dashboard} = use_app_context();
    const {info} = dashboard;
    const [active_tab, set_active_tab] =
        useState<'active_plans'|'plan_history'>('active_plans');
    const {set_qs} = use_qs_with_set();
    const show_promo = info.inited && !info.zone_groups?.length &&
        show_free_plan_promo(info.orders, info.free_zone_params);
    const pricing_plans_debug = use_debug_ui('pricing_plans');
    const debug_token_panel_ui = use_debug_ui('new_token_panel_ui');
    const show_pricing_plans = pricing_plans_debug
        || www_hola.dashboard_pricing_plans;
    const show_pricing_promo = active_tab=='active_plans' && show_promo
        && show_pricing_plans;
    const show_pricing_cards = user && !has_active_plan(info.orders)
        && show_pricing_plans && !info.zone_groups?.length;
    return <div className={styles.my_plans_container}>
      <div className={cn(styles.panel_header_wrapper, styles.plans_content)}>
        <h1 className={cn(styles.panel_header, theme.H3)}>
          <T>My proxies</T></h1>
        {!debug_token_panel_ui && <div className={styles.buttons}>
          {user && <Button caption='API token' color='transparent' size='s'
            on_click={()=>set_qs({show_api_token: 'y'})} fit round={false} />}
        </div>}
      </div>
      {!show_pricing_promo && (debug_token_panel_ui ?
        <div className={cn(styles.plans_content, styles.plans_content_debug)}>
          <div className={styles.plan_tabs}>
            <Button caption={t('Active plans')}
              cls={cn(styles.tab,
                active_tab == 'active_plans' && styles.active)}
              color={'transparent_grey'}
              on_click={()=>set_active_tab('active_plans')}/>
            <Button caption={t('Plan history')}
              color={'transparent_grey'}
              cls={cn(styles.tab,
                active_tab == 'plan_history' && styles.active)}
              on_click={()=>set_active_tab('plan_history')} />
          </div>
          {active_tab == 'active_plans' && <div className={styles.buttons}>
            {user && <Button caption='API token' color='transparent'
              on_click={()=>set_qs({show_api_token: 'y'})} fit
              cls={styles.api_token_btn} round={false} size='xs'/>}
          </div>}
        </div> :
        <div className={cn(styles.plans_content, styles.plan_tabs)}>
          <Button caption={t('Active plans')}
            cls={cn(styles.tab, active_tab == 'active_plans' && styles.active)}
            color={'transparent_grey'}
            on_click={()=>set_active_tab('active_plans')}/>
          <Button caption={t('Plan history')}
            color={'transparent_grey'}
            cls={cn(styles.tab, active_tab == 'plan_history' && styles.active)}
            on_click={()=>set_active_tab('plan_history')} />
        </div>)}
      {active_tab == 'active_plans' && (show_promo ?
        <Welcome_promo /> :
        show_pricing_cards ? <Pricing_cards/> :
        <Active_plans countries={props.countries}
          need_login={props.need_login}/>)}
      {active_tab == 'plan_history' && <Plan_history orders={info.orders}
        groups={info.zone_groups}
        countries={props.countries}/>}
      <Rate_us product_name='toolip' ui_border
        rate_us_url="https://www.trustpilot.com/review/toolip.io" />
      {user && <Api_token_panel />}
    </div>;
};
